<template>
	<li
		class="sidebar-cart__list-item sidebar-cart__list-item--configurable"
	>
		<span class="sidebar-cart__list-item-info">
			<span
				class="sidebar-cart__list-item-name"
				v-html="item.name"
			/>
			<span
				class="sidebar-cart__list-item-meta"
				v-if="item.variant"
				v-html="item.variant"
			/>
		</span>

		<div class="sidebar-cart__list-item-quantity">
			<button
				class="sidebar-cart__list-item-quantity-minus"
				@click="$emit('remove')"
				:disabled="locked"
			>
				<SVGTrash/>
			</button>
			<span
				class="sidebar-cart__list-item-quantity-value"
			/>
			<button
				class="sidebar-cart__list-item-quantity-plus"
				@click="$emit('copy')"
				:disabled="locked"
			>
				<SVGDuplicate/>
			</button>
		</div>

		<span
			class="sidebar-cart__list-item-price"
			v-html="$options.filters.madpricecent(item.originalTotal, 'short')"
		/>

		<div
			class="sidebar-cart__list-item-details"
		>
			<div
				class="sidebar-cart__list-item-options"
				v-if="selectedOptions"
				v-html="selectedOptions"
			/>
			<div
				class="sidebar-cart__list-item-extras"
				v-if="selectedExtras"
			>
				<span
					class="sidebar-cart__list-item-subtitle"
					v-if="selectedOptions"
					v-html="$t('childproducts.extrasTitle')"
				/>
				<span
					class="sidebar-cart__list-item-options"
					v-html="selectedExtras"
				/>
			</div>
			<Button
				class="sidebar-cart__list-item-edit"
				type="button"
				level="tertiary"
				:text="$t('cart.itemEdit')"
				arrow
				:disabled="locked"
				@click.prevent="$emit('edit')"
			/>
		</div>
	</li>
</template>

<script>
import QuantityCounter from '@/components/QuantityCounter';
import Button from '@/components/Button';

export default {
	components: {
		QuantityCounter,
		Button,
	},
	props: {
		item: Object,
		locked: Boolean,
	},
	computed: {
		selectedChildrenByType() {
			return this.item.children.reduce((acc, child) => {
				if (!Array.isArray(acc[child.type])) {
					acc[child.type] = [];
				}

				acc[child.type].push(child.name);
				return acc;
			}, {});

		},
		selectedOptions() {
			return this.selectedChildrenByType.option ?
				this.selectedChildrenByType.option.join(', ') :
				'';
		},
		selectedExtras() {
			return this.selectedChildrenByType.extra ?
				this.selectedChildrenByType.extra.join(', ') :
				'';
		},
	},
	mounted() {
		const parent = this.$el.parentNode;
		parent.scrollTop = parent.scrollHeight;
	}
}
</script>

<style>

</style>
